<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="I want to give">
            <div style="position:relative">
              <AmountSelectorList/>
              <ErrorLabel field="amount" style="text-align:right"/>
            </div>
            <TransactionFee />
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false"/>
            </FormRow>
          </FormSection>
          <PaymentButton  btnText="Donate Now"/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm()

    return {
      form,
      setValue
    }
  },
})
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1AA8D3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep #amount_other {
  padding-left: 70px !important;
  max-width: 100% !important;
}

::v-deep .styled-radio-container .amount_other__wrapper::after {
  top: 15px !important;
}

::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount_other__wrapper::before {
	content: "";
}
</style>

